import { render, staticRenderFns } from "./TopContent.vue?vue&type=template&id=4db25a2f&"
import script from "./TopContent.vue?vue&type=script&lang=ts&"
export * from "./TopContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Notice: require('/opt/atlassian/pipelines/agent/build/components/Notice.vue').default,Modal: require('/opt/atlassian/pipelines/agent/build/components/Modal.vue').default})
